import { fabric } from 'fabric'
import http from '@/utils/http'
import util from '@/utils/util'

const config = {
  textWidth: 100,
  fontSize: 24,
  brushWidth: 2,
  fill: '#FF676C', // 填充颜色
  fontWeight: 800, // e.g. bold, normal, 400, 600, 800
  fontFamily: 'Arial, Helvetica, sans-serif'
}

export const xDraw = {
  canvasImages: ['canvas-right', 'canvas-half-right', 'canvas-wrong'],
  objects: [],
  canvasList: [],
  textbox: null,
  getNewUrl,
  initCanvas (dom, img) {
    xDraw.textbox = null
    // console.log('init-canvas', this.objects.length, this.canvasList.length)
    fabric.Object.prototype.customProperties = ['id'];
    const canvas = new fabric.Canvas(dom, {
      includeDefaultValues: false,
      width: dom.offsetWidth,
      height: dom.offsetHeight,
      selection: false
    });
    this.canvasList.push(canvas)
    canvas.freeDrawingBrush.color = config.fill
    canvas.freeDrawingBrush.width = config.brushWidth
    canvas.on('path:created', opt => {
      const path = opt.path;
      path.selectable = false;// 禁用选择
      path.set({ objectCaching: !path.selectable }); // 启用缓存以提高性能
      path.evented = false; // 禁用事件（可选）
    });
    canvas.on('object:added', e => {
      // console.log('e.target.type', e.target.type)
      if (e.target.type === 'textbox' && xDraw.textbox) {
        e.target.enterEditing();
        e.target.hiddenTextarea.focus();
      } else {
        e.target.selectable = false
        e.target.hasControls = false
      }
      if (e.target.id) {
        // console.log(`级联：添加排除${e.target.id}`)
      } else {
        this.objects.push(e.target);
        // console.log(`级联：添加后共有${this.objects.length}个`)
      }
    });
    canvas.on('object:removed', e => {
      const index = this.objects.indexOf(e.target)
      if (index >= 0) {
        this.objects.splice(index, 1)
      }
      // console.log(`级联：删除索引${index}, 删除后共有${this.objects.length}个`)
    });
    canvas.on('selection:created', function (e) {
      var selectedObject = e.selected[0];
      // console.log('selectedObject', selectedObject.type)
      if (selectedObject && selectedObject.type === 'textbox') {
        selectedObject.set({
          borderDashArray: [3, 2] // 设置边框为虚线（5px实线，5px空白）
        });
        canvas.renderAll();
      }
    });
    return canvas
  },
  scorePlusAdd (point, score) {
    const text = new fabric.Text('+' + score, {
      left: point.x - 10,
      top: point.y - 14,
      fontSize: config.fontSize,
      fontWeight: config.fontWeight,
      fontFamily: config.fontFamily,
      fill: '#00CFA0',
      stroke: '#fff',
      strokeWidth: 1,
      selectable: false,
      hasControls: false
    });
    text.id = `score_plus_${Math.round(text.left)}_${Math.round(text.top)}`
    return text
  },
  scoreMinusAdd (point, score) {
    const text = new fabric.Text('' + score, {
      left: point.x - 10,
      top: point.y - 14,
      fontSize: config.fontSize,
      fontWeight: config.fontWeight,
      fontFamily: config.fontFamily,
      fill: config.fill,
      stroke: '#fff',
      strokeWidth: 1,
      selectable: false,
      hasControls: false
    });
    text.id = `score_minus_${Math.round(text.left)}_${Math.round(text.top)}`
    return text
  },
  tickAdd (point) {
    return getImageObj(point, this.canvasImages[0])
  },
  crossAdd (point) {
    return getImageObj(point, this.canvasImages[2])
  },
  tickCrossAdd (point) {
    return getImageObj(point, this.canvasImages[1])
  },
  textAdd: function (point, width) {
    const option = {
      left: point.x,
      top: point.y - 10,
      width: width - point.x - 4,
      fontSize: config.fontSize,
      borderColor: config.fill,
      fontWeight: config.fontWeight,
      fontFamily: config.fontFamily,
      fill: config.fill,
      stroke: '#fff',
      hasControls: false,
      selectable: true,
      splitByGrapheme: true, // 自动换行
    }
    const textbox = new fabric.Textbox("", option);
    this.textbox = textbox
    return textbox
  },
  blurTextbox (canvas) {
    if (this.textbox) {
      this.textbox.exitEditing();
    }
    // 移除无效输入框
    const textboxs = canvas.getObjects().filter(item => item.type === 'textbox' && !item.text)
    // console.log('检查无效输入框', canvas.getObjects(), textboxs)
    for (let index = 0; index < textboxs.length; index++) {
      const element = textboxs[index];
      // console.log('移除无效输入框', element)
      canvas.remove(element)
    }
  },
  cancelAction () {
    // console.log('撤销最近')
    const obj = this.objects[this.objects.length - 1]
    if (obj && obj.canvas) {
      obj.canvas.remove(obj)
    }
  },
  clearAction () {
    // console.log('清除所有', this.objects.length)
    // 有意思：必须倒叙移除才能移除完
    // 这里遍历objects一一移除，而不是使用clear批量移除，是为了防止"打标记"被误删
    for (let index = this.objects.length - 1; index >= 0; index--) {
      const obj = this.objects[index];
      // console.log('清除', index)
      obj.canvas.remove(obj)
    }
  },
  resetAction () {
    this.objects = []
    this.canvasList = []
  },
  exportAction (img) {
    for (let index = 0; index < this.images.length; index++) {
      const img = this.images[index];
      this.exportFile(img)
    }
  },
  exportFile (img) {
    // 按原始大小导出
    img.canvas.setZoom(1);
    const zoom = img.canvas.getZoom()
    img.canvas.setWidth(img.rawWidth * zoom);
    img.canvas.setHeight(img.rawHeight * zoom);
    // 移除背景图片
    img.canvas.setBackgroundImage(null, img.canvas.renderAll.bind(img.canvas));
    const apiJson = {
      code: 200,
      body: img.canvas.toObject(['id']),
      message: '批注json文件'
    }
    if (apiJson.body.objects && apiJson.body.objects.length) {
      img.jsonFile = new Blob([JSON.stringify(apiJson)], { type: 'application/json' })
      img.svgFile = new Blob([img.canvas.toSVG()], { type: 'image/svg+xml' })
    } else {
      img.jsonFile = null
      img.svgFile = null
    }
  },
  renderCanvas (img, callback) {
    const mark = img.scores.find(item => item.jsonUrl)
    const canvas = img.canvas
    if (mark) {
      http.get(mark.jsonUrl).then(resp => {
        if (resp.body) {
          canvas.loadFromJSON(resp.body, () => {
            // console.log('加载到json数据，设置背景图片')
            setBackgroundImage(img.src, canvas, callback)
          });
        }
      })
    } else {
      // // console.log('旧数据，设置背景图片')
      this.renderOldCanvas(img.scores, canvas)
      setBackgroundImage(img.src, canvas, callback)
    }
  },
  canAdd (canvas, target) {
    let oldTarget = null
    const list = canvas.getObjects()
    const zoom = canvas.getZoom()
    // 在恢复，在正常情况下判断重叠
    canvas.setZoom(1)
    for (let index = 0; index < list.length; index++) {
      const obj = list[index];
      // 排除自由绘制的线条
      if (obj.path && obj.path.find(items => items.find(item => item === 'Q'))) {
        continue
      }
      if (target.intersectsWithObject(obj)) {
        oldTarget = obj
        break
      }
    }
    // 在恢复，否则重叠判断不准确
    canvas.setZoom(zoom)
    return oldTarget === null
  },
  renderOldCanvas (list, canvas) {
    for (let index = 0; index < list.length; index++) {
      const element = list[index];
      // 如果相加之和为0，表示是批注模式
      const left = parseFloat(element.style.left)
      const top = parseFloat(element.style.top)
      if (left + top === 0) continue
      const point = {
        x: left + 14,
        y: top + 18
      }
      const score = element.value
      let obj = {}
      if (score >= 0) {
        obj = this.scorePlusAdd(point, score)
      } else {
        obj = this.scoreMinusAdd(point, score)
      }
      // 绑定对象id
      element.id = obj.id
      canvas.add(obj)
    }
  },
  getTools () {
    const list = [
      {
        label: '手写',
        type: 'brush'
      },
      {
        label: '输入文字',
        type: 'text'
      },
      {
        label: '对(✓)',
        type: 'tick'
      },
      {
        label: '半对(乄)',
        type: 'tickCross'
      },
      {
        label: '错(×)',
        type: 'cross'
      }
    ]
    return list
  },
  markPaper (promise1, promise2 = null) {
    return new Promise((resolve, reject) => {
      promise1.then(resp1 => {
        if (resp1.body && resp1.body.length) {
          const paperPromises = resp1.body.map(paper => {
            return new Promise((resolvePaper, rejectPaper) => {
              exportSvg(paper, canvas => {
                markPaper1(canvas, paper, 0, () => {
                  if (!util.isEmpty(promise2)) {
                    promise2.then(resp2 => {
                      if (resp2.body) {
                        const paperGradingTeacher = resp2.body[paper.resultId] || []
                        let targets = paperGradingTeacher.filter(item => item.pageIndex === paper.pageIndex)
                        // 没找到的话，默认将所有评阅信息，ps到第一张图里
                        if (targets.length === 0) {
                          targets = paperGradingTeacher
                        }
                        markPaper2(canvas, targets, () => {
                          resolvePaper(canvas.toDataURL())
                        })
                      } else {
                        resolvePaper(canvas.toDataURL())
                      }
                    }).finally(() => {
                      canvas.dispose()
                    })
                  } else {
                    resolvePaper(canvas.toDataURL())
                    canvas.dispose()
                  }
                })
              })
            })
          })

          Promise.all(paperPromises).then(results => {
            resolve({ success: true, body: results })
          })
        } else {
          resolve({ success: false })
        }
      })
    })
  }
}

function getImageObj (point, id) {
  const imgElement = document.getElementById(id);
  return new fabric.Image(imgElement, {
    left: point.x - 8,
    top: point.y - 8,
    scaleX: 0.5, // 设置水平缩放
    scaleY: 0.5,  // 设置垂直缩放
    hasControls: false,
    selectable: false
  })
}

function setBackgroundImage (url, canvas, callback) {
  fabric.Image.fromURL(url, function (image) {
    // 设置图像的宽度和高度，以适应画布大小
    image.scaleToWidth(canvas.getWidth());
    image.scaleToHeight(canvas.getHeight());
    // 将图像添加到画布的底层
    canvas.setBackgroundImage(image, canvas.renderAll.bind(canvas));
    if (callback) {
      callback(canvas)
    }
  });
}


// 绘制试卷评分情况
function markPaper1 (canvas, paper, qIndex = 0, callback) {
  const questions = paper.questionMarkingTrace
  if (qIndex >= questions.length) {
    if (callback) {
      callback()
    }
    return
  }
  const ques = questions[qIndex];
  const url = getNewUrl(ques.ossUrl.replace('.svg', '.json'))
  http.get(url).then(resp => {
    if (resp.body) {
      // 从其精简对象中创建相应的fabricjs结构实例
      fabric.util.enlivenObjects(resp.body.objects, objects => {
        for (let oIndex = 0; oIndex < objects.length; oIndex++) {
          const obj = objects[oIndex];
          obj.left = obj.left + ques.x
          obj.top = obj.top + ques.y
          canvas.add(obj)
        }
        markPaper1(canvas, paper, ++qIndex, callback)
      })
    }
  })
}

// 绘制教师评分情况
function markPaper2 (canvas, texts, callback) {
  for (let tIndex = 0; tIndex < texts.length; tIndex++) {
    const text = texts[tIndex];
    const textbox = getTextbox(text)
    canvas.add(textbox)
  }
  if (callback) {
    callback()
  }
}

function getTextbox (item) {
  const textbox = new fabric.Textbox(item.text, {
    splitByGrapheme: true, // 自动换行
    width: item.w,
    left: item.x,
    top: item.y,
    fontSize: 16,
    fontFamily: config.fontFamily,
    fill: 'red',
    selectable: false,
    evented: false,
  })
  return textbox
}

function exportSvg (paper, callback) {
  const id = 'mark-paper-canvas'
  let canvasEl = document.getElementById(id)
  if (!canvasEl) {
    canvasEl = document.createElement('canvas')
    canvasEl.id = id
    canvasEl.style.display = 'none'
    document.body.appendChild(canvasEl)
  }
  const canvas = new fabric.Canvas(canvasEl, {
    width: paper.paperPosition.w,
    height: paper.paperPosition.h,
    includeDefaultValues: false,
    selection: false,
    containerClass: 'custom-canvas'
  });
  const url = getNewUrl(paper.paperUrl)
  setBackgroundImage(url, canvas, () => {
    const svg = getNewUrl(paper.paperSvg)
    fabric.loadSVGFromURL(svg, objects => {
      for (let index = 0; index < objects.length; index++) {
        const element = objects[index];
        element.set({
          stroke: undefined,
        });
        canvas.add(element)
      }
      if (callback) {
        callback(canvas)
      }
    })
  })
}

function getNewUrl (url) {
  return url.replace('https://' + process.env.OSS_BUCKET + '.oss-cn-hangzhou.aliyuncs.com', location.origin + '/ali-oss')
}


// WEBPACK FOOTER //
// ./src/v2/utils/draw.js